import {Dialog, FormSubmitHandler} from 'platform/components';

import {FieldErrors} from 'react-hook-form';

import {suffixTestId, TestIdProps, noop} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {useCreatePageContext} from '../../Create/components/CreatePageContext';
import {VehicleFeatures} from '../../Create/components/VehicleFeatures';
import {VehicleFormType} from '../../Create/types/VehicleFormType';

interface EditEquipmentModalProps extends TestIdProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: FormSubmitHandler<VehicleFormType>;
  onInvalidSubmit?: (errors: FieldErrors<VehicleFormType>) => void;
}

export function EditEquipmentModal(props: EditEquipmentModalProps) {
  const {formApi} = useCreatePageContext();
  const handleSave = () => {
    formApi.handleSubmit(props.onSubmit ?? noop, props.onInvalidSubmit ?? noop)();
  };
  return (
    <Dialog
      title={i18n.t('page.import.actions.editEquipment')}
      isOpen={props.isOpen}
      onClose={props.onClose}
      buttons={[
        {
          title: i18n.t('general.actions.cancel'),
          variant: 'secondary',
          onClick: props.onClose,
          'data-testid': suffixTestId('cancelButton', props),
        },
        {
          title: i18n.t('general.actions.save'),
          onClick: handleSave,
          'data-testid': suffixTestId('saveButton', props),
        },
      ]}
      data-testid={suffixTestId('modal', props)}
    >
      <VehicleFeatures data-testid={suffixTestId('vehicleFeatures', props)} />
    </Dialog>
  );
}
